import script from "./MyProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProxy.vue?vue&type=script&setup=true&lang=js"

import "./MyProxy.vue?vue&type=style&index=0&id=cc8f8dea&lang=css"
import "./MyProxy.vue?vue&type=style&index=1&id=cc8f8dea&scoped=true&lang=css"
import "./MyProxy.vue?vue&type=style&index=2&id=cc8f8dea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc8f8dea"]])

export default __exports__